import { render } from "./InscriptionGroupe.vue?vue&type=template&id=b1d75a6a"
import script from "./InscriptionGroupe.vue?vue&type=script&lang=js"
export * from "./InscriptionGroupe.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__